<template>
  <section class="">
    <div
      class="px-4 mx-auto max-w-7xl lg:px-16"
      :class="[
        paddingTop === 'reduced' ? 'pt-6 lg:pt-6' : 'pt-12 lg:pt-16',
        paddingBottom === 'reduced' ? 'pb-6 lg:pb-6' : 'pb-12 lg:pb-16'
      ]"
    >
      <div class="">
        <div class="flex flex-col gap-4 py-[25px] rounded-[15px]">
          <h2
            v-if="title"
            class="text-center text-[11px] leading-[18.7px] tracking-[1.43px] uppercase text-[#F1574B] font-ww-regular"
            v-html="title"
          />

          <div
            v-if="content"
            class="pt-[2.89px] text-center text-[11.5px] leading-[19.55px] tracking-[0.46px] text-[#4A4A4A] capitalize font-ww-regular"
            v-html="content"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: 'Medical Disclaimer'
  },
  content: {
    type: String,
    default:
      'This content is for informational and educational purposes only. It is not intended to provide medical advice or to take the place of such advice or treatment from a personal physician. As medicine is constantly evolving and all bodies react differently, all readers/viewers of this content are advised to consult their doctors or qualified health professionals regarding specific health questions. Neither dr. charles livingston nor the publisher of this content takes responsibility for possible health consequences of any person or persons reading or following the information in this educational content. All viewers of this content, especially those taking prescription or over-the-counter medications, should consult their physicians before beginning any nutrition, supplement or lifestyle program. Additionally, the way coffee is grown, low acid coffee, decaf coffee, as well as different roast types (light, medium, dark, etc.) can alter caffeine levels. If you have questions about the caffeine levels or ph levels of our coffee, please reach out to our team for clarification. If you have any concerns with how our coffee, or any product will affect you or your health, consult with a health professional directly.'
  },
  paddingTop: {
    type: String,
    default: 'reduced',
    validator: (value) => ['default', 'reduced'].includes(value)
  },
  paddingBottom: {
    type: String,
    default: 'reduced',
    validator: (value) => ['default', 'reduced'].includes(value)
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Medical Disclaimer',
  inputs: [
    {
      name: 'title',
      type: 'text',
      defaultValue: 'Medical Disclaimer'
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue:
        'This content is for informational and educational purposes only. It is not intended to provide medical advice or to take the place of such advice or treatment from a personal physician. As medicine is constantly evolving and all bodies react differently, all readers/viewers of this content are advised to consult their doctors or qualified health professionals regarding specific health questions. Neither dr. charles livingston nor the publisher of this content takes responsibility for possible health consequences of any person or persons reading or following the information in this educational content. All viewers of this content, especially those taking prescription or over-the-counter medications, should consult their physicians before beginning any nutrition, supplement or lifestyle program. Additionally, the way coffee is grown, low acid coffee, decaf coffee, as well as different roast types (light, medium, dark, etc.) can alter caffeine levels. If you have questions about the caffeine levels or ph levels of our coffee, please reach out to our team for clarification. If you have any concerns with how our coffee, or any product will affect you or your health, consult with a health professional directly.'
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
